import { BORDERS, COLOR, FIXED_INDENTS } from 'vars/index'

export const TabBackground = {
  COLOR_TRANSPARENT: COLOR.TRANSPARENT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  ACCENT_ACCENT_TERTIARYPRIMARY: COLOR.ACCENT_TERTIARY,
  ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  ACCENT_PRIMARY_PRESSED: COLOR.ACCENT_PRIMARY_PRESSED,
  BUTTON_ACCENT_PRIMARY_GRADIENT: COLOR.BUTTON_ACCENT_PRIMARY_GRADIENT,
} as const
export type TabBackground = (typeof TabBackground)[keyof typeof TabBackground]

export const TabBorders = {
  SIZE_20: [BORDERS.BORDER_0, BORDERS.BORDER_0, BORDERS.BORDER_20],
}
export type TabBorder = (typeof TabBorders)[keyof typeof TabBorders]

export const TabPaddings = {
  SIZE_10: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_0],
  SIZE_20: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_60],
  SIZE_30: [FIXED_INDENTS.INDENT_20],
}
export type TabPadding = (typeof TabPaddings)[keyof typeof TabPaddings]
